if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.theme.jsCartCounter = {
  update: () => {
    fetch('/cart.js').then(response => response.json()).then(data => {
      [...document.querySelectorAll('[data-cart-state]')].forEach(counter => {
        counter.dataset.cartState = data.item_count > 0 ? data.item_count : '';
      });
      [...document.querySelectorAll('[ data-cart-item-count]')].forEach(counter => {
        counter.innerText = data.item_count > 0 ? data.item_count : '';
      });
    });
  }
};
